import {h, Fragment} from "preact"
export default function Loader({ className }) {
    return (
        <div className={`ns-loader-wrapper w-full h-full flex items-center justify-center ${className}`}>
            <div className="ns-loader" />
        </div>
    )
}